import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'
import { Node } from 'rete'

import { BaseFlowButtonWithOutput } from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import MessageEditorWithMediaData from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { SocketsActionsTypes } from '../../../../../../../components'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import { SendMessageNode } from '../../SendMessageNode'
import SendMessageAction from '../../actions/SendMessageAction'
import { MessageNodeActionTypes } from '../../types'
import ProxySendMessageNodeAction from './ProxySendMessageNodeAction'

export default class ProxySendMessageAction implements ProxySendMessageNodeAction {
  action: SendMessageAction

  guid: string = Guid.create().toString()

  private socketsActions: SocketsActionsTypes

  constructor(action: SendMessageAction, socketsActions: SocketsActionsTypes) {
    this.action = action
    this.socketsActions = socketsActions

    if (action.variants.length) {
      action.variants[0].buttons.forEach((r) => r.forEach((b) => {
        if (b instanceof BaseFlowButtonWithOutput && b.output) {
          socketsActions.createOutput(b.output)
        }
      }))
    }
  }

  async changeMessage(messages: Array<MessageEditorWithMediaData>, node: SendMessageNode, editor: CustomEditor): Promise<void> {
    const availableButtons: Array<BaseFlowButtonWithOutput> = []
    const movedSockets: Array<number> = []

    this.action.variants[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        availableButtons.push(b)
      }
    }))

    messages[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        const isExistButton = availableButtons.find((ab) => ab.guid === b.guid )

        if (isExistButton && isExistButton.output) {
          b.output = isExistButton.output

          availableButtons.splice(availableButtons.indexOf(isExistButton), 1)

          this.socketsActions.switchIsMoved(b.output, true)
          movedSockets.push(b.output)
        } else {
          b.output = this.socketsActions.createOutput()
        }
      }
    }))

    this.action.variants = messages

    requestAnimationFrame(() => movedSockets.forEach((id) => this.socketsActions.switchIsMoved(id, false)))

    requestAnimationFrame(() => {
      availableButtons.forEach((b) => {
        if (b.output) {
          this.socketsActions.deleteOutput(b.output)
        }
      })
    })

    await node.update()
    editor.view.updateConnections({ node: node as unknown as Node })
  }

  getModel(): SendMessageAction {
    return this.action
  }

  static getDefaultActionModel(): SendMessageAction {
    return plainToInstance(SendMessageAction, {
      type: MessageNodeActionTypes.Message,
      variants: [
        {
          text: '',
          attachments: [],
          buttons: []
        }
      ]
    })
  }

}
